import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { CreditsInfo } from '@app/shared/models/credits-info';
import { MaxCredits } from '@app/shared/models/max-credits';

@Injectable({
  providedIn: 'root',
})
export class CreditsInfoService extends ApiService {
  constructor() {
    super();
    this.url = 'contact/';
  }

  getCreditsInfo(): Observable<CreditsInfo> {
    return this.get({ url: 'getCredit' });
  }

  getMaxCredits(): Observable<MaxCredits> {
    return this.get({ url: 'getMaxCredits' });
  }
}
